// src/services/storeAnalytics.js
import instance from "../axios";

export const getSMDSummary = async ({ dateFrom, dateTo, smdId } = {}) => {
  const params = {};

  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  if (smdId) params.smdId = smdId;

  const response = await instance.get(`analytics/smd/summary`, { params });
  return response.data;
};
export const getNotes = async (params = {}) => {
  const queryParams = {};
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;
  const response = await instance.get("analytics/notes", { params: queryParams });
  return response.data;
};
export const getSummary = async (params = {}) => {
  const queryParams = {};
  
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;

  const response = await instance.get("analytics/stores/summary", { params: queryParams });
  return response.data;
};
export const getStockSummary = async (params = {}) => {
  const queryParams = {};
  
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;
  if (params.includeTopProducts) queryParams.includeTopProducts = params.includeTopProducts; // NEW PARAM

  const response = await instance.get("analytics/stocks/summary", { params: queryParams });
  return response.data;
};
export const getDashboardMetrics = async (params = {}) => {
  const queryParams = {};
  
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;

  const response = await instance.get("analytics/dashboard/metrics", { params: queryParams });
  return response.data;
};

export const getMapDistribution = async (params = {}) => {
  const queryParams = {};
  
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;

  const response = await instance.get("analytics/stores/map-distribution", { params: queryParams });
  return response.data;
};
export const getVisitTrends = async (period, params = {}) => {
  const queryParams = { period };
  
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;

  const response = await instance.get(`analytics/dashboard/visit-trends`, { params: queryParams });
  return response.data;
};

// Visibility trends over time (e.g., weekly, monthly)
export const getVisibilityTrends = async (period, params = {}) => {
  const queryParams = { period };

  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;

  const response = await instance.get(`analytics/stores/visibility-trend`, { params: queryParams });
  return response.data;
};
export const getMostVisitedStores = async (params = {}) => {
  const queryParams = {};
  
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;

  const response = await instance.get(`analytics/dashboard/most-visited-stores`, { params: queryParams });
  return response.data;
};

export const getGeographicDistribution = async () => {
  const response = await instance.get("analytics/geographic");
  return response.data;
};

export const getSalesPerformance = async () => {
  const response = await instance.get("analytics/performance");
  return response.data;
};

export const getStoreDetails = async (id) => {
  const response = await instance.get(`stores/${id}`);
  return response.data;
};

export const updateStore = async (id, data) => {
  const response = await instance.put(`stores/${id}`, data);
  return response.data;
};

export const createStore = async (data) => {
  const response = await instance.post("stores", data);
  return response.data;
};

export const deleteStore = async (id) => {
  const response = await instance.delete(`stores/${id}`);
  return response.data;
};

export const getStoreVisitations = async (storeId) => {
  const response = await instance.get(`stores/${storeId}/visitations`);
  return response.data;
};

export const getStoreStock = async (storeId) => {
  const response = await instance.get(`stores/${storeId}/stock`);
  return response.data;
};

export const getStorePerformanceMetrics = async (storeId) => {
  const response = await instance.get(`stores/${storeId}/metrics`);
  return response.data;
};

export const exportStoreData = async (params) => {
  const response = await instance.get("stores/export", {
    params,
    responseType: "blob", // Important for file downloads
  });
  return response.data;
};

// Monthly stock totals per store for a recent period (e.g., last 6 months)
export const getStockPerStoreMonthly = async (params = {}) => {
  const queryParams = {};
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.months) queryParams.months = params.months; // optional number of months back
  if (params.smdId) queryParams.smdId = params.smdId;
  if (params.provinceId) queryParams.provinceId = params.provinceId;
  if (params.cityId) queryParams.cityId = params.cityId;

  const response = await instance.get("analytics/stores/stock-monthly", { params: queryParams });
  return response.data;
};
